import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-documentos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './documentos.component.html',
  styleUrl: './documentos.component.css',
})
export class DocumentosComponent implements OnInit {
  documents: any[] = [];
  filteredDocuments: any[] = [];
  searchText: string = '';
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 1;
  idUnidadFuncional: string | null = null; // Para almacenar el ID de unidad funcional
  user: any = null; // Para almacenar la información del usuario desde localStorage
  selectedStatus: string = '';
  selectedDateOrder: string = '';
  selectedOficina: string = '';
  selectedTipoDocumento: string = '';
  oficinas: any[] = [];
  tiposDocumento: any[] = ['PDF', 'WORD', 'EXCEL'];

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadUserData();
    this.loadOficinas();
    this.cargarDocumentos();
  }

  loadUserData(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      this.user = JSON.parse(userData);
      this.idUnidadFuncional = this.user?.id_unidad_funcional || null;
      //console.log(this.idUnidadFuncional);
    } else {
      console.error('No se encontró información de usuario en localStorage.');
    }
  }

  loadOficinas(): void {
    this.http.get<any[]>(environment.apiUrl + '/oficina').subscribe(
      (data) => {
        this.oficinas = data;
      },
      (error) => {
        console.error('Error al obtener oficinas:', error);
      }
    );
  }

  cargarDocumentos(): void {
    let apiUrl = environment.apiUrl + '/documento';
    const queryParams: any = {};

    if (this.selectedStatus) {
      //console.log(this.selectedStatus);
      queryParams.estado = this.selectedStatus;
    }
    if (this.selectedDateOrder) {
      queryParams.by_date = this.selectedDateOrder;
    }
    if (this.selectedOficina) {
      queryParams.id_oficina = this.selectedOficina;
    }
    if (this.selectedTipoDocumento) {
      queryParams.tipo_documento = this.selectedTipoDocumento;
    }

    this.http.get<any[]>(apiUrl, { params: queryParams }).subscribe(
      (data) => {
        //console.log(data);
        this.documents = data;
        this.filteredDocuments = data; // Inicializar filteredDocuments con la lista completa
        this.updatePagination();
      },
      (error) => {
        console.error('Error al obtener documentos:', error);
      }
    );
  }

  applyFilter(): void {
    // Filtrar la lista completa de documentos
    this.filteredDocuments = this.documents.filter(
      (doc) =>
        doc.nombre
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase()) ||
        doc.id_documento
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase())
    );

    // Reiniciar la paginación a la primera página
    this.currentPage = 1;

    // Actualizar la paginación
    this.updatePagination();
  }

  updatePagination(): void {
    this.totalPages = Math.ceil(this.filteredDocuments.length / this.pageSize);
  }

  // Nuevo método para obtener los documentos visibles en la página actual
  getPaginatedDocuments(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.filteredDocuments.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.updatePagination();
  }

  eliminarDocumento(id: number): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.http.delete(environment.apiUrl + `/documento/${id}`).subscribe(
          () => {
            Swal.fire(
              'Eliminado',
              'La institución ha sido eliminada.',
              'success'
            );
            this.cargarDocumentos(); // Refresca la lista
          },
          (error) => {
            Swal.fire(
              'Error',
              error.error.message || 'No se pudo eliminar el documento.',
              'error'
            );
          }
        );
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/main']);
  }

  goToCreateDocument(): void {
    this.router.navigate(['/create-documento']);
  }

  goToDocumentDetail(doc: any): void {
    this.router.navigate(['/documento'], {
      queryParams: { id_documento: doc.id_documento },
    });
  }

  goToLoadedDocuments(doc: any): void {
    this.router.navigate(['/documentos-cargados'], {
      queryParams: { id_documento: doc.id_documento },
    });
  }
}
